import type { TimeType } from './generic'

export type ReportType = {
  content: string
  createdAtTime?: TimeType
  id: string
}

export enum ReportTemplateType {
  BENEFICIARY_REPORT = 'beneficiary_report',
}

export type ReportTemplateDTO = {
  createdAt: TimeType
  description?: string
  id: string
  instructions: string
  name: string
  type: ReportTemplateType
  updatedAt: TimeType
}
